export default __webpack_public_path__ + "static/media/close.38da0629.svg";